export function formatDate(str, isDash = false, isDateInput = false, isMonthFirst = false) {
  if (isMonthFirst==true) {
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(str)) {
      let inComingDate;
      const [month, day, year] = str.split('/');
      inComingDate = new Date(+year, +month - 1, +day);
      return `${day}/${month}/${year}`;
    }
  }
  let date;

  // Detect DD/MM/YYYY format
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(str)) {
    const [day, month, year] = str.split('/');
    date = new Date(+year, +month - 1, +day);
  } else {
    date = new Date(str); // fallback for ISO or standard formats
  }
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  if (isDateInput) {
    return `${year}-${month}-${day}`;
  }
  if (isDash) {
    return `${day}-${month}-${year}`;
  } else {
    return `${day}/${month}/${year}`;
  }
}
